import { dialogs, type Dialogs } from './dialogStore';

/**
 * Meldungen und Rückfragen statt alert, confirm und prompt des Browsers:
 *
 *   const dlg = useDialogs();
 *   if (!(await dlg.confirm({ title: 'Eintrag löschen?', message: '…', danger: true }))) return;
 *   try { … } catch (e) { await dlg.error('Löschen fehlgeschlagen', e); }
 *
 * Außerhalb von Komponenten: `dialogs` direkt importieren.
 */
export function useDialogs(): Dialogs {
  return dialogs;
}
